/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Process_Step3_DescInputs */

const et_process_step3_desc = /** @type {(inputs: Process_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimeerime igakuiselt lehte, reklaame ja sisu, kuni päringute kasv on käes.`)
};

const en_process_step3_desc = /** @type {(inputs: Process_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We optimize your pages, campaigns, and content monthly until inquiry growth is achieved.`)
};

/**
* | output |
* | --- |
* | "We optimize your pages, campaigns, and content monthly until inquiry growth is achieved." |
*
* @param {Process_Step3_DescInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const process_step3_desc = /** @type {((inputs?: Process_Step3_DescInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Process_Step3_DescInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_process_step3_desc(inputs)
	return en_process_step3_desc(inputs)
});